import callApi from './partials/api';

export default {
    // FAQ 常見問題
    queryCompany({CompanyId}, cb) {
        callApi('post', `QuestionAnswer/QueryCompany`, cb, {
            data: {
                CompanyId,
            }
        });
    },
    get(cb) {
        callApi('post', `QuestionAnswer/Get`, cb);
    },

}